var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useState, useCallback } from 'react';
import { useDrop } from "react-dnd";
import update from "immutability-helper";
import Chips from './chips';
import { sortArrayOfObjects } from '../../../utils/CommonUtil';
import './metric-select.scss';
var ChipWrapper = function (props) {
    var data = props.data, onChangeMetric = props.onChangeMetric, multiple = props.multiple, isAllowDrag = props.isAllowDrag, multipleIcon = props.multipleIcon, categoryMetric = props.categoryMetric;
    var _a = useState(), chipData = _a[0], setChipData = _a[1];
    var _b = useDrop({ accept: "Card" }), drop = _b[1];
    useEffect(function () {
        if (data) {
            sortArrayOfObjects(data, 'dimensionAble', true);
            setChipData(data);
        }
    }, [data]);
    var onChangeMetricChip = function (chipItem) {
        if (chipData) {
            var chipList = __spreadArrays(chipData);
            if (multiple) {
                var foundChipItem = chipList.findIndex(function (chip) { return chip.id == chipItem.id; });
                if (foundChipItem > -1) {
                    chipList[foundChipItem].selected = chipList[foundChipItem].selected ? false : true;
                }
            }
            else {
                chipList = chipList.map(function (chip) {
                    if (chip.id == chipItem.id) {
                        chip.selected = true;
                    }
                    else {
                        chip.selected = false;
                    }
                    return chip;
                });
            }
            setChipData(chipList);
            onChangeMetric(chipList, chipItem);
        }
    };
    var moveCard = useCallback(function (dragIndex, hoverIndex) {
        if (chipData) {
            var dragCard = chipData[dragIndex];
            var hoverCard = chipData[hoverIndex];
            if (dragCard.dimensionAble != hoverCard.dimensionAble)
                return;
            if (dragCard.dimensionAble === hoverCard.dimensionAble) {
                var chipDataAfterDrag = update(chipData, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, dragCard],
                    ],
                });
                setChipData(chipDataAfterDrag);
                onChangeMetric(chipDataAfterDrag);
            }
        }
    }, [chipData]);
    return React.createElement("div", { ref: drop, className: "chip-inline-container" }, chipData && chipData.length ? chipData.map(function (item, index) {
        return React.createElement(Chips, { classes: "chip-container-style " + (item.selected ? "chip-container-style-selected" : "") + " " + (categoryMetric && (item.isLogicGA || item.isBlockChart) ? "chip-category-GA" : ""), chips: chipData, data: item, onChangeMetricChip: onChangeMetricChip, id: item.id, multipleIcon: multipleIcon, moveCard: moveCard, index: index, key: item.id, isAllowDrag: isAllowDrag, isDimension: item.dimensionAble });
    })
        : null);
};
export default ChipWrapper;
